// Chaves do localStorage do tema. Módulo folha, sem imports, para que
// assets/ts/layout/ThemeMode.ts possa usá-las sem carregar o índice de
// partials (que importa ThemeMode de volta e fechava um ciclo de imports).
export const themeModelSKey = 'kt_theme_mode_value'
export const themeMenuModeLSKey = 'kt_theme_mode_menu'
